module.exports = __webpack_public_path__ + "static/media/Hamdi-Halimi.01a880f4.pdf";